<template>
    <component :is="lazyTemplate">
        <v-layout justify-center align-center>
            <v-responsive width="100vw" max-width="1200" class="py-8">
                <v-card width="100%">
                    <v-card-title class="tit tit--lg">
                        <span class="py-4 pl-4"><b>간편결제 이용약관</b></span>
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                        <v-responsive max-height="60vh" class="overflow-auto">
                            <div v-if="termsItem" v-html="termsItem.content" />
                            <!-- 약관이 아직 등록되지 않은 상태. 결제창에서 열리는 페이지이므로 빈 화면 대신 안내를 띄운다. -->
                            <div v-else class="py-8 text-center grey--text">등록된 간편결제 이용약관이 없습니다.</div>
                        </v-responsive>
                    </v-card-text>
                </v-card>
            </v-responsive>
        </v-layout>
    </component>
</template>

<script>
import api from "@/api";

// 내 통장 결제(오픈뱅킹) 간편결제 이용약관.
// KG이니시스 WPAY 회원가입 화면의 "이용약관 동의" 링크(agreeUrl)가 이 주소를 연다.
// 본문은 콘솔(/console/terms)에서 약관코드 "openbank" 로 등록하면 여기에 그대로 노출된다.
const TERMS_CODE = "openbank";

export default {
    data() {
        return {
            termsItem: null,
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            try {
                let { termsList } = await api.v1.terms.gets({ params: { code: TERMS_CODE } });
                this.termsItem = termsList?.[0] || null;
            } catch (error) {
                // 약관을 못 불러와도 결제창 흐름을 막지 않는다 — 안내 문구만 남긴다.
                console.error(error);
                this.termsItem = null;
            }
        },
    },
    computed: {
        lazyTemplate() {
            return () => import(`@/templates/${this.$theme.pages.login}`);
        },
    },
};
</script>
